module.exports = __webpack_public_path__ + "static/media/gapahuk.856b7dc3.svg";